import React, { useState } from 'react';
import BurCarousel from './components/BurCarousel';
import BlurpCarousel from './components/BlurpCarousel';
import Acts from "./components/Acts";
import News from "./components/News";
import { Services } from "./components/Services";
import { Events } from "./components/Events";
import { Calendar } from "./components/Calendar";
import { Contact } from "./components/Contact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import NavBar from './components/Navbar';


export default function Main() {
    const [selectedSection, setSelectedSection] = useState('news'); // domyślnie aktualności

    return (
        <div>
            <NavBar onSelectSection={(section) => setSelectedSection(section)}/>

            <div id="carousel">
                <BurCarousel/>
            </div>

            {selectedSection === 'news' && (
                <div id="news" className="my-5">
                    <News/>
                </div>
            )}

            {selectedSection === 'acts' && (
                <div id="acts" className="my-5">
                    <Acts/>
                </div>
            )}

            {selectedSection === 'services' && (
                <div id="services" className="my-5">
                    <Services/>
                </div>
            )}

            {selectedSection === 'events' && (
                <div id="events" className="my-5">
                    <Events/>
                </div>
            )}

            {selectedSection === 'calendar' && (
                <div id="calendar" className="my-5">
                    <Calendar/>
                    <BlurpCarousel/>
                </div>
            )}

            <div id="contact" className="footer">
                <Contact/>
            </div>
            <div className="bg-dark-pink text-light text-center footer">
                &copy; <a className="border-bottom" href="#carousel">NaniCarduelis.com</a>, All Right Reserved.
            </div>

            {/*<a href="#carousel" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top"*/}
            {/*   aria-label="Back to top">*/}
            {/*    <FontAwesomeIcon icon={faArrowUp}/>*/}
            {/*</a>*/}
        </div>
    );
}
